import { useState } from "react";
import { useTranslation } from "react-i18next";
import BaseInput from "../BaseInput";

const formatCNPJ = (value) => {
    if (!value) return value;
    const digits = value.replace(/\D/g, "").slice(0, 14);

    if (digits.length <= 2) {
        return digits;
    } else if (digits.length <= 5) {
        return `${digits.slice(0, 2)}.${digits.slice(2)}`;
    } else if (digits.length <= 8) {
        return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`;
    } else if (digits.length <= 12) {
        return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8)}`;
    } else {
        return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
    }
};

const CNPJInput = ({ value, onInput, label, placeholder = '00.000.000/0000-00', variant = 'light', ...props }) => {
    const { t } = useTranslation('fragments');
    const [localValue, setLocalValue] = useState(value ? formatCNPJ(value) : "");

    const handleChange = (newValue) => {
        const digits = newValue.replace(/\D/g, "").slice(0, 14);
        const displayValue = formatCNPJ(digits);
        setLocalValue(displayValue);
        onInput(digits);
    };

    return (
        <BaseInput
            {...props}
            value={localValue}
            onInput={handleChange}
            label={label ?? t('common:fields.cnpj')}
            placeholder={placeholder}
            variant={variant}
            maxLength={18}
        />
    );
};

export default CNPJInput;
